import script from "./CorporateIdentityLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorporateIdentityLayout.vue?vue&type=script&setup=true&lang=ts"

import "./CorporateIdentityLayout.vue?vue&type=style&index=0&id=3926898b&lang=css"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QPageContainer});
